import * as React from 'react';
import { Link } from 'react-router-dom';
import * as ReqType from '../../../types/ServerRequests';
import { LoaderButton } from '../../genericComponents/Button/LoaderButton';
import { SubscriptionsService } from '../../../services/SubscriptionService';

interface Props {
    inscription: ReqType.Subscription;
    validateInscription: (e: ReqType.Subscription) => void;
}

interface State {
}

/**
 * Ce composant permet d'afficher une ligne de la liste des subscriptions
 */
export class SubscriptionLine extends React.Component {
    state: State;
    props: Props;

    constructor(props: Props) {
        super(props);
    }

    render() {
        return (
            <tr key={this.props.inscription.id}>
                <td scope="row">{this.props.inscription.user.username}</td>
                <td scope="row">{this.convState(this.props.inscription.etat)}</td>
                <td>
                    <Link to={'/subscriptions/' + this.props.inscription.user.id}>
                        <button className="btn btn-default">
                            <i className="fas fa-plus" />
                        </button>
                    </Link>
                </td>
                <td>
                    <LoaderButton
                        className="btn btn-secondary badge-light"
                        confirmation={true}
                        disabled={this.props.inscription.etat !== ReqType.SubscriptionState.A_VALIDER}
                        modalTitle="Validation d'inscription"
                        modalBody={
                            'Souhaitez-vous vraiment valider l\'inscription de ' +
                            this.props.inscription.user.username +
                            '?'
                        }
                        onClick={
                            () => {
                                return SubscriptionsService
                                    .getInstance()
                                    .validateSubscription(this.props.inscription)
                                    .then(
                                        () => {
                                            this.props.validateInscription(this.props.inscription);
                                        }
                                    );
                            }
                        }
                    >
                        <strong>valider</strong>
                    </LoaderButton>
                </td>
            </tr>
        );
    }

    private convState(s: ReqType.SubscriptionState): string {
        if (s === ReqType.SubscriptionState.A_VALIDER) {
            return 'A valider';
        } else if (s === ReqType.SubscriptionState.EN_COURS) {
            return 'En cours';
        } else {
            return 'Validée';
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/SubscriptionManagmentPage/internalComponents/SubscriptionLine.tsx